import {
  GREEN_600,
  MOON_50,
  MOON_250,
  MOON_650,
  MOON_800,
  TEAL_500,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {IconCheckmark} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  background-color: white;
  padding: 16px;
  padding-bottom: 0px;
  border-radius: 4px;
  border: 1px solid ${MOON_250};
  margin-bottom: 40px;
  margin-right: 40px;
  justify-content: center;
`;
Panel.displayName = 'S.Panel';

export const Header = styled.div`
  display: flex;
  align-items: left;
  margin-bottom: 12px;
`;
Header.displayName = 'S.Header';

export const Title = styled.div`
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
`;
Title.displayName = 'S.Title';

export const Section = styled.div<{isSelected?: boolean; isBottom?: boolean}>`
  background-color: ${props => (props.isSelected ? `${MOON_50}` : `white`)};
  min-height: 44px;
  padding: 4px 8px;
  margin: 0px -16px;
  ${props =>
    props.isBottom && !props.isSelected
      ? `border-radius: 0px 0px 4px 4px;`
      : ``}
  &:hover {
    background-color: ${MOON_50};
  }
  cursor: pointer;
`;
Section.displayName = 'S.Section';

export const Message = styled.div<{lightText?: boolean; isStatic?: boolean}>`
  font-weight: 400;
  max-width: 680px;
  font-size: 16px;
  line-height: 20.11px;
  margin: 12px 0px 12px 0px;
  color: ${props => (props.lightText ? `${MOON_650}` : `${MOON_800}`)};
  padding-left: ${props => (props.isStatic ? '0px' : '16px')};

  ol,
  ul {
    padding-left: 0px;
    margin: 0px;
  }
`;

Message.displayName = 'S.Message';
export const SectionHeader = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  align-items: center;
  display: flex;
`;
SectionHeader.displayName = 'S.SectionHeader';

export const ClickableText = styled.span`
  color: ${TEAL_600};
  font-weight: 600;
  &:hover {
    color: ${TEAL_500};
  }
  cursor: pointer;
`;
ClickableText.displayName = 'S.ClickableText';

export const Divider = styled.div`
  background-color: ${MOON_250};
  height: 1px;
  margin-left: -16px;
  margin-right: -16px;
`;
Divider.displayName = 'S.Divider';

export const InlineCode = styled.div`
  background-color: ${MOON_50};
  white-space: pre;
  font-family: monospace;
  display: inline-block;
`;
InlineCode.displayName = 'S.InlineCode';

export const CodeSnippet = styled.div`
  padding: 8px;
  background-color: ${MOON_50};
  display: flex;
  flex-direction: column;
  margin: 0 -4px 12px -4px;
  border-radius: 4px;
`;
CodeSnippet.displayName = 'S.CodeSnippet';

export const CodeSnippetHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'Source Sans Pro' !important;
`;
CodeSnippetHeader.displayName = 'S.CodeSnippetHeader';

export const Code = styled.code`
  flex: 1 1 auto;
  font-size: 12px;
  line-height: 15.08px;
  font-family: 'Source Code Pro';
  margin-top: 10px;
`;
Code.displayName = 'S.Code';

export const Checkmark = styled(IconCheckmark)`
  color: ${GREEN_600};
  margin-left: auto;
  margin-right: 14.65px;
  align-self: center;
`;
